// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609300334/js/" + chunkId + "." + {"44":"797af38b","225":"0976d849","481":"67844b14","486":"a1d5094d","770":"ea249342"}[chunkId] + ".0.5306080526214327.chunk.js";
};